export default __webpack_public_path__ + "static/media/P344_SOV.9f08d953.pdf";